import academicMd from './academic.md?raw'
import creativeMd from './creative.md?raw'
import professionalMd from './professional.md?raw'
import technicalMd from './technical.md?raw'

export interface ResumeTemplate {
  id: string
  name: string
  description: string
  category: 'professional' | 'creative' | 'technical' | 'academic'
  path: string
  content?: string
}

export const templates: ResumeTemplate[] = [
  {
    id: 'professional-classic',
    name: 'Professional Classic',
    description:
      'A clean, traditional resume format perfect for corporate roles',
    category: 'professional',
    content: professionalMd,
    path: `../lib/resume-templates/professional.md`,
  },
  {
    id: 'tech-developer',
    name: 'Technical Developer',
    description:
      'Optimized for technical roles with emphasis on skills and projects',
    category: 'technical',
    content: technicalMd,
    path: `../lib/resume-templates/technical.md`,
  },
  {
    id: 'creative-designer',
    name: 'Creative Designer',
    description: 'Modern layout for creative and design professionals',
    category: 'creative',
    content: creativeMd,
    path: `../lib/resume-templates/creative.md`,
  },
  {
    id: 'academic-researcher',
    name: 'Academic Researcher',
    description: 'Comprehensive format for academic and research positions',
    category: 'academic',
    content: academicMd,
    path: `../lib/resume-templates/academic.md`,
  },
]
